import Snappy from '../../../libs/snappy/snappy';
import $ from 'jquery';
import queryString from 'query-string';

Snappy.Component.SearchResults = class SearchResults extends Snappy.BaseComponent {
    static get tagName() {
        return 'cfa-search-results';
    }

    constructor(element) {
        super(element);
    }

    render() {
        this.setVars();
        this.setEventListeners();
    }

    setVars() {
        this.$contentContainer = this.$element.find('.js-content-container');
        this.$searchInput = this.$element.find('.js-search-input');
        this.$submitButton = this.$element.find('.js-search-submit-button');
        this.$keyword = this.$searchInput.val();
        this.$handler = this.$element.data('url');
        this.$pages = this.$element.find('.js-content-page');
        this.$prevNextPage = this.$element.find('.js-content-page-prev-next');
        this.paramsArr = [];
        this.selectedValue = '';
        this.isLoading = false;
        this.currentPage = 1;
    }

    setEventListeners() {
        this.bindEventListeners();
        this.$window.on('popstate', this.onPopState.bind(this));
    }

    bindEventListeners() {
        this.unbindEventListeners();
        this.$searchInput.on('keyup', this.bindedKeyupListeners = this.onKeyup.bind(this));
        this.$submitButton.on('click', this.bindedSubmitListeners = this.onSubmit.bind(this));
        this.$pages.on('click', this.bindedPageListeners = this.changePage.bind(this));
        this.$prevNextPage.on('click', this.bindedPrevNextPageListeners = this.onPrevNextClick.bind(this));
    }

    unbindEventListeners() {
        this.$searchInput.off('keyup', this.bindedKeyupListeners);
        this.$submitButton.off('click', this.bindedSubmitListeners);
        this.$pages.off('click', this.bindedPageListeners);
        this.$prevNextPage.off('click', this.bindedPrevNextPageListeners);
    }

    changePage(e) {
        e.preventDefault();
        let page = $(e.target).data('page-number');

        this.onPageChange(page);
    }

    onPrevNextClick(e){
        e.preventDefault();

        let link = $(e.target),
            linkType,
            page;

        if (!link.is('a')) {
            link = link.parents('a');
        }

        linkType = link.data('page-type');

        this.currentPage = this.$pages.filter('.is-active').data('page-number');

        page = linkType === 'prev' ? --this.currentPage : ++this.currentPage;

        this.onPageChange(page);
    }

    onPageChange(page){
        this.paramsArr = [];

        if (this.$keyword !== 'null' && this.$keyword !== '') {
            this.paramsArr.push('keyword=' + this.$keyword);
        }

        if (page !== '') {
            this.paramsArr.push('page=' + page);
        }

        this.updateURLHash(this.$keyword, page);
        this.fetchData();
    }

    fetchData(){
        let paramsStr = this.paramsArr.join('&'),
            url = this.$handler + '?' + paramsStr;

        this.isLoading = true;
        this.toggleLoading();

        //TODO: later remove commented setTimeout as it was added for testing
        // setTimeout(function(){
            $.ajax({
                url: url,
                type: "GET",
                dataType: "html",
                success: this.handleSuccess.bind(this),
                error: this.handleError.bind(this)
            })
        // }.bind(this), 3000);

    }

    handleSuccess(response) {
        this.isLoading = false;
        this.toggleLoading();
        this.$contentContainer.empty().html(response);
        this.$window.trigger('content:updated');
        this.$pages = this.$contentContainer.find('.js-content-page');
        this.$prevNextPage = this.$contentContainer.find('.js-content-page-prev-next');
        this.$searchInput = this.$contentContainer.find('.js-search-input');
        this.$submitButton = this.$contentContainer.find('.js-search-submit-button');
        this.bindEventListeners();
        this.scrollToTop();
    }

    handleError(response) {
        console.log(response);
    }

    toggleLoading(){
        const preloader = this.$element.find('.js-cfa-preloader');

        preloader.toggleClass('cfa-preloader--active', this.isLoading);
    }

    scrollToTop() {
        $("html, body").animate({ scrollTop: 0 }, 200);
    }

    onKeyup(e) {
        if (event && event.keyCode === 13) {
            this.onSubmit();
        }
    }

    onSubmit(e) {
        const keyword = this.$searchInput.val();
        this.$keyword = keyword;

        if (keyword === '') {
            return;
        }

        this.paramsArr = [];
        this.currentPage = 1;

        if (keyword !== 'null' && keyword !== '') {
            this.paramsArr.push('keyword=' + keyword);
        }

        this.paramsArr.push('page=' + this.currentPage);

        this.updateURLHash(keyword, this.currentPage);
        this.fetchData();
    }

    updateURLHash(keyword, page) {
        let parsedSearchString = queryString.parse(location.search);
        parsedSearchString['keyword'] = keyword;
        parsedSearchString['page'] = page;

        const convertedQuery = queryString.stringify(parsedSearchString),
            URL = location.pathname + '?' + convertedQuery + location.hash;

        if ('pushState' in history) {
            history.pushState({}, document.title, URL);
        }
    }

    onPopState() {
        let parsedSearchString = queryString.parse(location.search);

        this.$keyword = parsedSearchString['keyword'];
        this.currentPage = parsedSearchString['page'];

        this.paramsArr = [];

        if (this.$keyword !== 'null' && this.$keyword !== '') {
            this.paramsArr.push('keyword=' + this.$keyword);
        }

        this.paramsArr.push('page=' + this.currentPage);

        this.fetchData();
    }
};



// WEBPACK FOOTER //
// ./components/cfa-search-results/scripts/cfa-search-results.js